import { useQuery } from '@apollo/client';

import GET_USER_HASHED_EMAIL from './get-user-hashed-email.graphql';

type UseUserHashedEmailValue = {
  isUserHashedEmailError: boolean;
  isUserHashedEmailLoading: boolean;
  userHashedEmail: string | null | undefined;
};

export const useUserHashedEmail = (): UseUserHashedEmailValue => {
  const { error, loading, data } = useQuery(GET_USER_HASHED_EMAIL);
  const userHashedEmail = data?.viewer?.b2bProfileSettings?.hashedEmail;
  return {
    isUserHashedEmailError: !!error,
    isUserHashedEmailLoading: loading,
    userHashedEmail,
  };
};
